'use client';
import { useEffect, useState } from 'react';
import { getShellProfile } from '@/app/services/shellApi';

export function useShellProfile(ownerId?: string) {
  const [profile, setProfile] = useState<{ ownerId: string; picture: string | null; name: string | null } | null>(null);
  useEffect(() => {
    if (!ownerId) return;
    let active = true;
    void getShellProfile(ownerId).then(value => {
      if (active) setProfile({ ownerId, picture: value?.profile_picture_url ?? null, name: value?.display_name ?? null });
    }).catch(() => { if (active) setProfile(null); });
    return () => { active = false; };
  }, [ownerId]);
  return profile?.ownerId === ownerId ? profile : null;
}
